<template lang="pug">
  .balance
    .toolbar
      .mobile-title
        span.mobile-title__number.semibold 03
        span Целевые показатели по обезвреживанию, утилизации и размещению отходов
      .top-header
        h1.title {{$route.meta ? $route.meta.title : '' }}
        .toolbar.toolbar--modal.toolbar_no-padding(v-if="fieldYears.length" )
          .toolbar__line.line
            div.parameters
              select.select.e-year-select(v-model="year" @change="getRowYear()")
                option(v-for="option in fieldYears" :value="option") {{option}}

    .content.overflow-visible.max-height-initial
      .wrapper
        .table.table_balance(v-if="items")
          .table__header
            .table__row
              .table__col.table__head(
                v-for="field in items._meta?.fields"
                :class="field.hasOwnProperty('childs')?'table__head_with-children':''"
                :style="field.hasOwnProperty('childs')?`min-width:calc(130px * ${getLength(field.childs)})` : ''"
              ) {{field.hasOwnProperty('childs') ? '' : field.label }}
                span(v-if="field.hasOwnProperty('childs')" ) {{field.label}}
                .display-flex(v-if="field.hasOwnProperty('childs')" :style="`min-width:calc(130px * ${getLength(field.childs)})`")
                  .table__col.table__head(
                    v-for="child in field.childs"
                    :class="child.hasOwnProperty('childs')?'table__head_with-children':''"
                    :style="child.hasOwnProperty('childs')?`min-width:calc(130px * ${getLength(child.childs)})` : ''"
                  ) {{child.hasOwnProperty('childs') ? '' : child.label}}
                    span(v-if="child.hasOwnProperty('childs')" ) {{child.label}}
                    .display-flex(v-if="child.hasOwnProperty('childs')" :style="`min-width:calc(130px * ${getLength(child.childs)})`")
                      .table__col.table__head(
                        v-for="ch in child.childs"
                      ) {{ch.label}}
          .table__body
            .table__row(v-for="(block, i) in dataRow" :key="'block-'+i")
              .table__col(v-for="item in list" :key="item.name")
                span.text-center(
                  v-model="block[item.name]"
                  :data-key="'list-'+item.name"
                ) {{block[item.name]}}
        div.tooltip__body-item(v-else)
          span.info.info--grey Нет данных
</template>

<script>
import { report } from '@/api/api-endpoints'
import routeMixin from '@/mixins/route-mixin'
import year from '@/utils/year'

export default {
  name: 'balanceTotalCharacteristics',
  mixins: [routeMixin],
  data() {
    return {
      query: '',
      items: [],
      year: '',
      list: [],
      fieldYears: [],
      dataRow: [],
    }
  },
  watch: {
    $route: function () {
      this.resetData()
      this.getData()
    },
  },

  methods: {
    resetData() {
      this.items = []
      this.list = []
      this.fieldYears = []
      this.dataRow = []
    },

    checkYears() {
      this.items.data.forEach((el) => {
        if (el.hasOwnProperty('year')) {
          this.fieldYears.push(el.year)
        }
      })
      if (this.fieldYears.length) {
        this.year = this.fieldYears[this.fieldYears.length - 1]
        this.dataRow = [this.items.data.find(({ year }) => year === this.year)]
      } else {
        this.year = year.getCurrentYear()
      }
    },

    async getData() {
      const type = this.$route.meta?.type
        ? this.$route.meta?.type
        : 'balanceTotalCharacteristics'
      this.items = await (
        await this.$store.dispatch('updateUrlEndpoint', {
          endpoint: report.tables(this.$route, type),
        })
      ).data
      this.dataRow = this.items.data
      this.getListField()
      this.checkYears()
    },

    //формирование шапки таблицы расчитано на 3 уровня вложенности
    getLength(arr) {
      let length = arr.length
      arr.forEach((el) => {
        if (el.hasOwnProperty('childs')) {
          el.childs.forEach((el2) => {
            if (el2.hasOwnProperty('childs')) {
              length = length + el2.childs.length - 1
            }
          })
          length = length + el.childs.length - 1
        }
      })
      return length
    },

    getListField() {
      if (!this.items) return
      this.items._meta.fields.forEach((elem) => {
        if (elem.hasOwnProperty('path')) {
          this.list.push({ name: elem.path })
        }
        if (elem.hasOwnProperty('childs')) {
          elem.childs.forEach((el) => {
            if (el.hasOwnProperty('path')) {
              this.list.push({ name: el.path })
            }
            if (el.hasOwnProperty('childs')) {
              el.childs.forEach((e) => {
                if (e.hasOwnProperty('path')) {
                  this.list.push({ name: e.path })
                }
              })
            }
          })
        }
      })
    },
    getRowYear() {
      this.dataRow = [this.items.data.find(({ year }) => year === this.year)]
    },
  },
  created() {
    this.getData()
  },
}
</script>

<style scoped lang="scss">
@import '../../assets/scss/utils/variables';
@import '../../assets/scss/utils/mixins';

.main-layout {
  .content {
    .wrapper {
      width: max-content;
      max-width: calc(100vw - 60px);
    }
    .table {
      overflow-y: auto;
      max-height: calc(100vh - 166px);

      &__col {
        line-height: 17px;
        box-sizing: border-box;
      }

      .display-flex > .table__col {
        border-right: 3px solid $grey-true !important;
      }

      &::-webkit-scrollbar {
        height: 6px;
        width: 6px;
      }

      &::-webkit-scrollbar-track {
        border-radius: 6px;
      }

      &::-webkit-scrollbar-thumb {
        border-radius: 6px;
        box-shadow: inset 0 0 6px rgba(170, 170, 170, 0.6);
      }
    }
  }
}

.top-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
</style>
